import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'contextual-menu-specs',
  templateUrl: './contextual-menu-specs.component.html',
  styleUrls: ['./contextual-menu-specs.component.sass']
})
export class ContextualMenuSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/contextualmenu/';

  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
